import MasterLayout from './MasterLayout';

export default MasterLayout;
